export default function StsPageDatePickerClickEventModel(action: string) {
    return {
        action
    }
}